import { OrderStatus } from '@cemex-core/cmx-api';
export interface OrderStatusModify {
  originalStatus: OrderStatus;
  haveChanges: boolean;
  colorSpecialScenario: boolean;
}

export enum SpecialScenarioCode {
  MULTIPLE_MIXES = 'MULTM',
  SAME_DAY = 'SDAY',
  AFTER_CUT_OFF = 'ACUT',
  SPECIAL_VAPS = 'SVAP',
  SPECIAL_INSTRUCTIONS = 'SINST',
  ORDER_WITH_COLOR = 'SCOL',
  SPACING_VS_VOLUMEN = 'SPCVL',
  VOLUMENT_QUOTE = 'VOLM',
  LARGE_ORDER = 'LARGE',
  FOREIGN_SERVICES = 'FORE',
  NO_AVAILABILITY = 'NOAV',
  REQUEST_TIME_AVAILABILITY = 'AVAIL',
  COUNTER_OFFER = 'CTRO',
  OUT_SERVICE_HOURS = 'OUTS',
  WAITING_LIST = 'WLIS',
  TEMPERATURE = 'TEMP',
  NON_WORKING_DAY = 'NBDAY',
  JOBSITE_OUT_RANGE = 'OOR',
  JOBSITE_RESTRICTED = 'RDTP',
  CERTIFIED_TRUCKS_DRIVERS = 'CERTD',
  SPECIALIZED_PRODUCT = 'SMIX',
}

export const FOREING_SERVICE_ERROR_CODE = '4507';
export const RESOURCE_NOT_FOUND = '404';
export const NO_AVAILABILITY_ERROR_CODE = '4501';
